// eslint-disable-next-line no-restricted-imports
import { defineMessages } from 'react-intl';

export const aiLanguageMessages: {
	// Language Messages
	readonly nestingParentTitle: {
		readonly id: 'fabric.editor.ai.config.item.translate.nestingParentTitle.ga';
		readonly defaultMessage: 'Translate';
		readonly description: 'The nested title which shows in the generative-ai-modal';
	};
	readonly nestingParentTitlePostGA: {
		readonly id: 'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA';
		readonly defaultMessage: 'Translate to ...';
		readonly description: 'The nested title which shows in the generative-ai-modal';
	};
	readonly chineseSimplified: {
		readonly id: 'fabric.editor.ai.config.item.translate.chineseSimplified';
		readonly defaultMessage: 'Chinese (Simplified)';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Chinese (Simplified)';
	};
	readonly chineseTraditional: {
		readonly id: 'fabric.editor.ai.config.item.translate.chineseTraditional';
		readonly defaultMessage: 'Chinese (Traditional)';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Chinese (Traditional)';
	};
	readonly czech: {
		readonly id: 'fabric.editor.ai.config.item.translate.czech';
		readonly defaultMessage: 'Czech';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Czech';
	};
	readonly danish: {
		readonly id: 'fabric.editor.ai.config.item.translate.danish';
		readonly defaultMessage: 'Danish';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Danish';
	};
	readonly dutch: {
		readonly id: 'fabric.editor.ai.config.item.translate.dutch';
		readonly defaultMessage: 'Dutch';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Dutch';
	};
	readonly english: {
		readonly id: 'fabric.editor.ai.config.item.translate.english';
		readonly defaultMessage: 'English';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for English';
	};
	readonly finnish: {
		readonly id: 'fabric.editor.ai.config.item.translate.finnish';
		readonly defaultMessage: 'Finnish';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Finnish';
	};
	readonly french: {
		readonly id: 'fabric.editor.ai.config.item.translate.french';
		readonly defaultMessage: 'French';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for French';
	};
	readonly german: {
		readonly id: 'fabric.editor.ai.config.item.translate.german';
		readonly defaultMessage: 'German';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for German';
	};
	readonly hungarian: {
		readonly id: 'fabric.editor.ai.config.item.translate.hungarian';
		readonly defaultMessage: 'Hungarian';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Hungarian';
	};
	readonly italian: {
		readonly id: 'fabric.editor.ai.config.item.translate.italian';
		readonly defaultMessage: 'Italian';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Italian';
	};
	readonly japanese: {
		readonly id: 'fabric.editor.ai.config.item.translate.japanese';
		readonly defaultMessage: 'Japanese';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Japanese';
	};
	readonly korean: {
		readonly id: 'fabric.editor.ai.config.item.translate.korean';
		readonly defaultMessage: 'Korean';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Korean';
	};
	readonly norwegian: {
		readonly id: 'fabric.editor.ai.config.item.translate.norwegian';
		readonly defaultMessage: 'Norwegian';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Norwegian';
	};
	readonly polish: {
		readonly id: 'fabric.editor.ai.config.item.translate.polish';
		readonly defaultMessage: 'Polish';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Polish';
	};
	readonly portugueseBrazilian: {
		readonly id: 'fabric.editor.ai.config.item.translate.portugueseBrazilian';
		readonly defaultMessage: 'Portuguese (Brazilian)';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Portuguese (Brazilian)';
	};
	readonly russian: {
		readonly id: 'fabric.editor.ai.config.item.translate.russian';
		readonly defaultMessage: 'Russian';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Russian';
	};
	readonly spanish: {
		readonly id: 'fabric.editor.ai.config.item.translate.spanish';
		readonly defaultMessage: 'Spanish';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Spanish';
	};
	readonly swedish: {
		readonly id: 'fabric.editor.ai.config.item.translate.swedish';
		readonly defaultMessage: 'Swedish';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Swedish';
	};
	readonly turkish: {
		readonly id: 'fabric.editor.ai.config.item.translate.turkish';
		readonly defaultMessage: 'Turkish';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Turkish';
	};
	readonly thai: {
		readonly id: 'fabric.editor.ai.config.item.translate.thai';
		readonly defaultMessage: 'Thai';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Thai';
	};
	readonly ukrainian: {
		readonly id: 'fabric.editor.ai.config.item.translate.ukrainian';
		readonly defaultMessage: 'Ukrainian';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Ukrainian';
	};
	readonly vietnamese: {
		readonly id: 'fabric.editor.ai.config.item.translate.vietnamese';
		readonly defaultMessage: 'Vietnamese';
		readonly description: 'Language string referenced in UIs involving the translation AI prompt for Vietnamese';
	};
	// Translate to messages
	readonly chineseSimplifiedTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.title';
		readonly defaultMessage: 'Translate to Chinese (Simplified)';
		readonly description: 'Title of a prompt that translates the selected content into Chinese (Simplified)';
	};
	readonly chineseSimplifiedDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.description';
		readonly defaultMessage: "Translates the text you're working on to Chinese (Simplified)";
		readonly description: 'Description for prompt that translates selected content into Chinese (Simplified)';
	};
	readonly chineseTraditionalTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.title';
		readonly defaultMessage: 'Translate to Chinese (Traditional)';
		readonly description: 'Title of a prompt that translates the selected content into Chinese (Traditional)';
	};
	readonly chineseTraditionalDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.description';
		readonly defaultMessage: "Translates the text you're working on to Chinese (Traditional)";
		readonly description: 'Description for prompt that translates selected content into Chinese (Traditional)';
	};
	readonly czechTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.czech.title';
		readonly defaultMessage: 'Translate to Czech';
		readonly description: 'Title of a prompt that translates the selected content into Czech';
	};
	readonly czechDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.czech.description';
		readonly defaultMessage: "Translates the text you're working on to Czech";
		readonly description: 'Description for prompt that translates selected content into Czech';
	};
	readonly danishTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.danish.title';
		readonly defaultMessage: 'Translate to Danish';
		readonly description: 'Title of a prompt that translates the selected content into Danish';
	};
	readonly danishDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.danish.description';
		readonly defaultMessage: "Translates the text you're working on to Danish";
		readonly description: 'Description for prompt that translates selected content into Danish';
	};
	readonly dutchTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.dutch.title';
		readonly defaultMessage: 'Translate to Dutch';
		readonly description: 'Title of a prompt that translates the selected content into Dutch';
	};
	readonly dutchDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.dutch.description';
		readonly defaultMessage: "Translates the text you're working on to Dutch";
		readonly description: 'Description for prompt that translates selected content into Dutch';
	};
	readonly englishTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.english.title';
		readonly defaultMessage: 'Translate to English';
		readonly description: 'Title of a prompt that translates the selected content into English';
	};
	readonly englishDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.english.description';
		readonly defaultMessage: "Translates the text you're working on to English";
		readonly description: 'Description for prompt that translates selected content into English';
	};
	readonly finnishTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.finnish.title';
		readonly defaultMessage: 'Translate to Finnish';
		readonly description: 'Title of a prompt that translates the selected content into Finnish';
	};
	readonly finnishDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.finnish.description';
		readonly defaultMessage: "Translates the text you're working on to Finnish";
		readonly description: 'Description for prompt that translates selected content into Finnish';
	};
	readonly frenchTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.french.title';
		readonly defaultMessage: 'Translate to French';
		readonly description: 'Title of a prompt that translates the selected content into French';
	};
	readonly frenchDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.french.description';
		readonly defaultMessage: "Translates the text you're working on to French";
		readonly description: 'Description for prompt that translates selected content into French';
	};
	readonly germanTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.german.title';
		readonly defaultMessage: 'Translate to German';
		readonly description: 'Title of a prompt that translates the selected content into German';
	};
	readonly germanDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.german.description';
		readonly defaultMessage: "Translates the text you're working on to German";
		readonly description: 'Description for prompt that translates selected content into German';
	};
	readonly hungarianTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.hungarian.title';
		readonly defaultMessage: 'Translate to Hungarian';
		readonly description: 'Title of a prompt that translates the selected content into Hungarian';
	};
	readonly hungarianDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.hungarian.description';
		readonly defaultMessage: "Translates the text you're working on to Hungarian";
		readonly description: 'Description for prompt that translates selected content into Hungarian';
	};
	readonly italianTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.italian.title';
		readonly defaultMessage: 'Translate to Italian';
		readonly description: 'Title of a prompt that translates the selected content into Italian';
	};
	readonly italianDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.italian.description';
		readonly defaultMessage: "Translates the text you're working on to Italian";
		readonly description: 'Description for prompt that translates selected content into Italian';
	};
	readonly japaneseTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.japanese.title';
		readonly defaultMessage: 'Translate to Japanese';
		readonly description: 'Title of a prompt that translates the selected content into Japanese';
	};
	readonly japaneseDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.japanese.description';
		readonly defaultMessage: "Translates the text you're working on to Japanese";
		readonly description: 'Description for prompt that translates selected content into Japanese';
	};
	readonly koreanTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.korean.title';
		readonly defaultMessage: 'Translate to Korean';
		readonly description: 'Title of a prompt that translates the selected content into Korean';
	};
	readonly koreanDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.korean.description';
		readonly defaultMessage: "Translates the text you're working on to Korean";
		readonly description: 'Description for prompt that translates selected content into Korean';
	};
	readonly norwegianTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.norwegian.title';
		readonly defaultMessage: 'Translate to Norwegian';
		readonly description: 'Title of a prompt that translates the selected content into Norwegian';
	};
	readonly norwegianDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.norwegian.description';
		readonly defaultMessage: "Translates the text you're working on to Norwegian";
		readonly description: 'Description for prompt that translates selected content into Norwegian';
	};
	readonly polishTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.polish.title';
		readonly defaultMessage: 'Translate to Polish';
		readonly description: 'Title of a prompt that translates the selected content into Polish';
	};
	readonly polishDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.polish.description';
		readonly defaultMessage: "Translates the text you're working on to Polish";
		readonly description: 'Description for prompt that translates selected content into Polish';
	};
	readonly portugueseBrazilianTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title';
		readonly defaultMessage: 'Translate to Portuguese (Brazilian)';
		readonly description: 'Title of a prompt that translates the selected content into Portuguese (Brazilian)';
	};
	readonly portugueseBrazilianDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description';
		readonly defaultMessage: "Translates the text you're working on to Portuguese (Brazilian)";
		readonly description: 'Description for prompt that translates selected content into Portuguese (Brazilian)';
	};
	readonly russianTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.russian.title';
		readonly defaultMessage: 'Translate to Russian';
		readonly description: 'Title of a prompt that translates the selected content into Russian';
	};
	readonly russianDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.russian.description';
		readonly defaultMessage: "Translates the text you're working on to Russian";
		readonly description: 'Description for prompt that translates selected content into Russian';
	};
	readonly spanishTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.spanish.title';
		readonly defaultMessage: 'Translate to Spanish';
		readonly description: 'Title of a prompt that translates the selected content into Spanish';
	};
	readonly spanishDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.spanish.description';
		readonly defaultMessage: "Translates the text you're working on to Spanish";
		readonly description: 'Description for prompt that translates selected content into Spanish';
	};
	readonly swedishTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.swedish.title';
		readonly defaultMessage: 'Translate to Swedish';
		readonly description: 'Title of a prompt that translates the selected content into Swedish';
	};
	readonly swedishDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.swedish.description';
		readonly defaultMessage: "Translates the text you're working on to Swedish";
		readonly description: 'Description for prompt that translates selected content into Swedish';
	};
	readonly turkishTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.turkish.title';
		readonly defaultMessage: 'Translate to Turkish';
		readonly description: 'Title of a prompt that translates the selected content into Turkish';
	};
	readonly turkishDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.turkish.description';
		readonly defaultMessage: "Translates the text you're working on to Turkish";
		readonly description: 'Description for prompt that translates selected content into Turkish';
	};
	readonly thaiTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.thai.title';
		readonly defaultMessage: 'Translate to Thai';
		readonly description: 'Title of a prompt that translates the selected content into Thai';
	};
	readonly thaiDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.thai.description';
		readonly defaultMessage: "Translates the text you're working on to Thai";
		readonly description: 'Description for prompt that translates selected content into Thai';
	};
	readonly ukrainianTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.ukrainian.title';
		readonly defaultMessage: 'Translate to Ukrainian';
		readonly description: 'Title of a prompt that translates the selected content into Ukrainian';
	};
	readonly ukrainianDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.ukrainian.description';
		readonly defaultMessage: "Translates the text you're working on to Ukrainian";
		readonly description: 'Description for prompt that translates selected content into Ukrainian';
	};
	readonly vietnameseTitle: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.vietnamese.title';
		readonly defaultMessage: 'Translate to Vietnamese';
		readonly description: 'Title of a prompt that translates the selected content into Vietnamese';
	};
	readonly vietnameseDescription: {
		readonly id: 'fabric.editor.ai.config.item.translateTo.vietnamese.description';
		readonly defaultMessage: "Translates the text you're working on to Vietnamese";
		readonly description: 'Description for prompt that translates selected content into Vietnamese';
	};
} = defineMessages({
	// Language Messages
	nestingParentTitle: {
		id: 'fabric.editor.ai.config.item.translate.nestingParentTitle.ga',
		defaultMessage: 'Translate',
		description: 'The nested title which shows in the generative-ai-modal',
	},
	nestingParentTitlePostGA: {
		id: 'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA',
		defaultMessage: 'Translate to ...',
		description: 'The nested title which shows in the generative-ai-modal',
	},
	chineseSimplified: {
		id: 'fabric.editor.ai.config.item.translate.chineseSimplified',
		defaultMessage: 'Chinese (Simplified)',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Chinese (Simplified)',
	},
	chineseTraditional: {
		id: 'fabric.editor.ai.config.item.translate.chineseTraditional',
		defaultMessage: 'Chinese (Traditional)',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Chinese (Traditional)',
	},
	czech: {
		id: 'fabric.editor.ai.config.item.translate.czech',
		defaultMessage: 'Czech',
		description: 'Language string referenced in UIs involving the translation AI prompt for Czech',
	},
	danish: {
		id: 'fabric.editor.ai.config.item.translate.danish',
		defaultMessage: 'Danish',
		description: 'Language string referenced in UIs involving the translation AI prompt for Danish',
	},
	dutch: {
		id: 'fabric.editor.ai.config.item.translate.dutch',
		defaultMessage: 'Dutch',
		description: 'Language string referenced in UIs involving the translation AI prompt for Dutch',
	},
	english: {
		id: 'fabric.editor.ai.config.item.translate.english',
		defaultMessage: 'English',
		description:
			'Language string referenced in UIs involving the translation AI prompt for English',
	},
	finnish: {
		id: 'fabric.editor.ai.config.item.translate.finnish',
		defaultMessage: 'Finnish',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Finnish',
	},
	french: {
		id: 'fabric.editor.ai.config.item.translate.french',
		defaultMessage: 'French',
		description: 'Language string referenced in UIs involving the translation AI prompt for French',
	},
	german: {
		id: 'fabric.editor.ai.config.item.translate.german',
		defaultMessage: 'German',
		description: 'Language string referenced in UIs involving the translation AI prompt for German',
	},
	hungarian: {
		id: 'fabric.editor.ai.config.item.translate.hungarian',
		defaultMessage: 'Hungarian',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Hungarian',
	},
	italian: {
		id: 'fabric.editor.ai.config.item.translate.italian',
		defaultMessage: 'Italian',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Italian',
	},
	japanese: {
		id: 'fabric.editor.ai.config.item.translate.japanese',
		defaultMessage: 'Japanese',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Japanese',
	},
	korean: {
		id: 'fabric.editor.ai.config.item.translate.korean',
		defaultMessage: 'Korean',
		description: 'Language string referenced in UIs involving the translation AI prompt for Korean',
	},
	norwegian: {
		id: 'fabric.editor.ai.config.item.translate.norwegian',
		defaultMessage: 'Norwegian',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Norwegian',
	},
	polish: {
		id: 'fabric.editor.ai.config.item.translate.polish',
		defaultMessage: 'Polish',
		description: 'Language string referenced in UIs involving the translation AI prompt for Polish',
	},
	portugueseBrazilian: {
		id: 'fabric.editor.ai.config.item.translate.portugueseBrazilian',
		defaultMessage: 'Portuguese (Brazilian)',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Portuguese (Brazilian)',
	},
	russian: {
		id: 'fabric.editor.ai.config.item.translate.russian',
		defaultMessage: 'Russian',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Russian',
	},
	spanish: {
		id: 'fabric.editor.ai.config.item.translate.spanish',
		defaultMessage: 'Spanish',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Spanish',
	},
	swedish: {
		id: 'fabric.editor.ai.config.item.translate.swedish',
		defaultMessage: 'Swedish',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Swedish',
	},
	turkish: {
		id: 'fabric.editor.ai.config.item.translate.turkish',
		defaultMessage: 'Turkish',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Turkish',
	},
	thai: {
		id: 'fabric.editor.ai.config.item.translate.thai',
		defaultMessage: 'Thai',
		description: 'Language string referenced in UIs involving the translation AI prompt for Thai',
	},
	ukrainian: {
		id: 'fabric.editor.ai.config.item.translate.ukrainian',
		defaultMessage: 'Ukrainian',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Ukrainian',
	},
	vietnamese: {
		id: 'fabric.editor.ai.config.item.translate.vietnamese',
		defaultMessage: 'Vietnamese',
		description:
			'Language string referenced in UIs involving the translation AI prompt for Vietnamese',
	},

	// Translate to messages
	chineseSimplifiedTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.title',
		defaultMessage: 'Translate to Chinese (Simplified)',
		description: 'Title of a prompt that translates the selected content into Chinese (Simplified)',
	},
	chineseSimplifiedDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.description',
		defaultMessage: "Translates the text you're working on to Chinese (Simplified)",
		description:
			'Description for prompt that translates selected content into Chinese (Simplified)',
	},
	chineseTraditionalTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.title',
		defaultMessage: 'Translate to Chinese (Traditional)',
		description:
			'Title of a prompt that translates the selected content into Chinese (Traditional)',
	},
	chineseTraditionalDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.description',
		defaultMessage: "Translates the text you're working on to Chinese (Traditional)",
		description:
			'Description for prompt that translates selected content into Chinese (Traditional)',
	},
	czechTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.czech.title',
		defaultMessage: 'Translate to Czech',
		description: 'Title of a prompt that translates the selected content into Czech',
	},
	czechDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.czech.description',
		defaultMessage: "Translates the text you're working on to Czech",
		description: 'Description for prompt that translates selected content into Czech',
	},
	danishTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.danish.title',
		defaultMessage: 'Translate to Danish',
		description: 'Title of a prompt that translates the selected content into Danish',
	},
	danishDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.danish.description',
		defaultMessage: "Translates the text you're working on to Danish",
		description: 'Description for prompt that translates selected content into Danish',
	},
	dutchTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.dutch.title',
		defaultMessage: 'Translate to Dutch',
		description: 'Title of a prompt that translates the selected content into Dutch',
	},
	dutchDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.dutch.description',
		defaultMessage: "Translates the text you're working on to Dutch",
		description: 'Description for prompt that translates selected content into Dutch',
	},
	englishTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.english.title',
		defaultMessage: 'Translate to English',
		description: 'Title of a prompt that translates the selected content into English',
	},
	englishDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.english.description',
		defaultMessage: "Translates the text you're working on to English",
		description: 'Description for prompt that translates selected content into English',
	},
	finnishTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.finnish.title',
		defaultMessage: 'Translate to Finnish',
		description: 'Title of a prompt that translates the selected content into Finnish',
	},
	finnishDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.finnish.description',
		defaultMessage: "Translates the text you're working on to Finnish",
		description: 'Description for prompt that translates selected content into Finnish',
	},
	frenchTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.french.title',
		defaultMessage: 'Translate to French',
		description: 'Title of a prompt that translates the selected content into French',
	},
	frenchDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.french.description',
		defaultMessage: "Translates the text you're working on to French",
		description: 'Description for prompt that translates selected content into French',
	},
	germanTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.german.title',
		defaultMessage: 'Translate to German',
		description: 'Title of a prompt that translates the selected content into German',
	},
	germanDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.german.description',
		defaultMessage: "Translates the text you're working on to German",
		description: 'Description for prompt that translates selected content into German',
	},
	hungarianTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.hungarian.title',
		defaultMessage: 'Translate to Hungarian',
		description: 'Title of a prompt that translates the selected content into Hungarian',
	},
	hungarianDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.hungarian.description',
		defaultMessage: "Translates the text you're working on to Hungarian",
		description: 'Description for prompt that translates selected content into Hungarian',
	},
	italianTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.italian.title',
		defaultMessage: 'Translate to Italian',
		description: 'Title of a prompt that translates the selected content into Italian',
	},
	italianDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.italian.description',
		defaultMessage: "Translates the text you're working on to Italian",
		description: 'Description for prompt that translates selected content into Italian',
	},
	japaneseTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.japanese.title',
		defaultMessage: 'Translate to Japanese',
		description: 'Title of a prompt that translates the selected content into Japanese',
	},
	japaneseDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.japanese.description',
		defaultMessage: "Translates the text you're working on to Japanese",
		description: 'Description for prompt that translates selected content into Japanese',
	},
	koreanTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.korean.title',
		defaultMessage: 'Translate to Korean',
		description: 'Title of a prompt that translates the selected content into Korean',
	},
	koreanDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.korean.description',
		defaultMessage: "Translates the text you're working on to Korean",
		description: 'Description for prompt that translates selected content into Korean',
	},
	norwegianTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.norwegian.title',
		defaultMessage: 'Translate to Norwegian',
		description: 'Title of a prompt that translates the selected content into Norwegian',
	},
	norwegianDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.norwegian.description',
		defaultMessage: "Translates the text you're working on to Norwegian",
		description: 'Description for prompt that translates selected content into Norwegian',
	},
	polishTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.polish.title',
		defaultMessage: 'Translate to Polish',
		description: 'Title of a prompt that translates the selected content into Polish',
	},
	polishDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.polish.description',
		defaultMessage: "Translates the text you're working on to Polish",
		description: 'Description for prompt that translates selected content into Polish',
	},
	portugueseBrazilianTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title',
		defaultMessage: 'Translate to Portuguese (Brazilian)',
		description:
			'Title of a prompt that translates the selected content into Portuguese (Brazilian)',
	},
	portugueseBrazilianDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description',
		defaultMessage: "Translates the text you're working on to Portuguese (Brazilian)",
		description:
			'Description for prompt that translates selected content into Portuguese (Brazilian)',
	},
	russianTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.russian.title',
		defaultMessage: 'Translate to Russian',
		description: 'Title of a prompt that translates the selected content into Russian',
	},
	russianDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.russian.description',
		defaultMessage: "Translates the text you're working on to Russian",
		description: 'Description for prompt that translates selected content into Russian',
	},
	spanishTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.spanish.title',
		defaultMessage: 'Translate to Spanish',
		description: 'Title of a prompt that translates the selected content into Spanish',
	},
	spanishDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.spanish.description',
		defaultMessage: "Translates the text you're working on to Spanish",
		description: 'Description for prompt that translates selected content into Spanish',
	},
	swedishTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.swedish.title',
		defaultMessage: 'Translate to Swedish',
		description: 'Title of a prompt that translates the selected content into Swedish',
	},
	swedishDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.swedish.description',
		defaultMessage: "Translates the text you're working on to Swedish",
		description: 'Description for prompt that translates selected content into Swedish',
	},
	turkishTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.turkish.title',
		defaultMessage: 'Translate to Turkish',
		description: 'Title of a prompt that translates the selected content into Turkish',
	},
	turkishDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.turkish.description',
		defaultMessage: "Translates the text you're working on to Turkish",
		description: 'Description for prompt that translates selected content into Turkish',
	},
	thaiTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.thai.title',
		defaultMessage: 'Translate to Thai',
		description: 'Title of a prompt that translates the selected content into Thai',
	},
	thaiDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.thai.description',
		defaultMessage: "Translates the text you're working on to Thai",
		description: 'Description for prompt that translates selected content into Thai',
	},
	ukrainianTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.ukrainian.title',
		defaultMessage: 'Translate to Ukrainian',
		description: 'Title of a prompt that translates the selected content into Ukrainian',
	},
	ukrainianDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.ukrainian.description',
		defaultMessage: "Translates the text you're working on to Ukrainian",
		description: 'Description for prompt that translates selected content into Ukrainian',
	},
	vietnameseTitle: {
		id: 'fabric.editor.ai.config.item.translateTo.vietnamese.title',
		defaultMessage: 'Translate to Vietnamese',
		description: 'Title of a prompt that translates the selected content into Vietnamese',
	},
	vietnameseDescription: {
		id: 'fabric.editor.ai.config.item.translateTo.vietnamese.description',
		defaultMessage: "Translates the text you're working on to Vietnamese",
		description: 'Description for prompt that translates selected content into Vietnamese',
	},
} as const);
